import { SYSTEM_ROLE_DEFINITIONS } from '@despachador/domain';

/** "Propietario RapiTaxi" → "PR": the first letters of the first two words. */
export const initials = (name: string) =>
  name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0]!.toUpperCase())
    .join('');

/** The name of a system role; its key for a role this panel does not know. */
export const roleName = (key: string) => SYSTEM_ROLE_DEFINITIONS[key as keyof typeof SYSTEM_ROLE_DEFINITIONS]?.name ?? key;

/** A Colombian mobile in groups (+57 300 100 0001); any other number as it is. */
export const phoneDisplay = (phone: string) => {
  const m = /^\+57(\d{3})(\d{3})(\d{4})$/.exec(phone);
  return m ? `+57 ${m[1]} ${m[2]} ${m[3]}` : phone;
};
